import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
  selector: 'sellions-icon-pulsar',
  templateUrl: 'sellions-icon-pulsar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellionsIconPulsarComponent {
  @Input() icon: string;

  constructor() {}

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-icon-pulsar/sellions-icon-pulsar.ts